"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEX_CONSTANT_CASE = exports.CONSECUTIVE_CHARS_REGEX = exports.SEQUENTIAL_CHARS_REGEX = exports.AIRTM_REGEX = exports.REGEX_FORM_FIELDS = exports.webappNames = exports.payoneer = exports.moonpay = exports.saasquatch = exports.rto = exports.dlocal = exports.verificationCodeTypes = exports.deviceTypes = exports.matchingPeerTypes = exports.virtualCardConstants = exports.auditReasons = exports.wyreCurrencies = exports.wyreAccounts = exports.kount = exports.signupSources = exports.cryptoBannedCountriesAndDates = exports.thirdPartyAuthProviders = exports.otpMethods = exports.bulkPayments = exports.transitions = exports.userMigrationStatus = exports.invitationStatus = exports.userTiers = exports.defaultImages = exports.userRoles = exports.puris = exports.phoneVerificationMethods = exports.paymentStatus = exports.paymentTypes = exports.paymentMethodRestrictions = exports.operationTags = exports.operationTypes = exports.operationStatus = exports.onfidoDocumentTypes = exports.mpms = exports.ledgerTransactions = exports.kafkaTopics = exports.cancellationReasons = exports.balanceTypes = exports.timeLapses = exports.blisseyCheckInStatus = exports.airmxnOperationTypes = exports.airmxnEventTypes = exports.accountTypes = exports.accountStatus = void 0;
exports.DEFAULT_CURRENCY_PRECISION = exports.LANGUAGES = exports.MAX_SECONDARY_EMAILS = exports.MAX_AIRMXN_MONTHLY_TRADE_OUT = exports.DEFAULT_SEND_FREE_AMOUNT_LIMIT = exports.DEFAULT_PARTNER_SEND_AMOUNT_LIMIT = exports.DEFAULT_SEND_AMOUNT_LIMIT = exports.MIN_AMOUNT_ENTERPRISE_PAYOUT = exports.MIN_AMOUNT_SEND_CRYPTO = exports.MIN_AMOUNT_SEND_USD = exports.MAX_AMOUNT_SEND_REQUEST_USD = exports.MAX_SEND_REQUESTS_MONTHLY = exports.MAX_SEND_REQUESTS_SAME_USER = exports.MAX_SEND_REQUEST_OPERATIONS = exports.UNLIMITED_ACCEPTORS = exports.MAX_UNCONFIRMED_ACCEPTED_SELLS = exports.MAX_TAKEN_PEER_TRANSFERS = exports.MAX_CREATED_PEER_TRANSFERS = exports.AIRTM_MIN_AGE = exports.MOBILE_PIN_REGEX = exports.WYRE_POSTAL_CODE_REGEX = exports.POSTCODE_GBR_REGEX = exports.PASSWORD_LETTER_REGEX = exports.PASSWORD_LENGTH_REGEX = exports.PASSWORD_NUMBER_REGEX = exports.PASSWORD_SPECIAL_CHARS_REGEX = exports.PHONE_REGEX = exports.PHONE_COUNTRY_CODE_REGEX = exports.REGEX_USERNAME = exports.REGEX_PURI_LIST = exports.REGEX_PURI = exports.REGEX_UUID_LIST = exports.REGEX_UUID = exports.REGEX_JWT = void 0;
exports.accountStatus = __importStar(require("./accountStatus"));
exports.accountTypes = __importStar(require("./accountTypes"));
exports.airmxnEventTypes = __importStar(require("./airmxnEventTypes"));
exports.airmxnOperationTypes = __importStar(require("./airmxnOperationTypes"));
exports.blisseyCheckInStatus = __importStar(require("./blisseyCheckInStatus"));
exports.timeLapses = __importStar(require("./timeLapses"));
exports.balanceTypes = __importStar(require("./balanceTypes"));
exports.cancellationReasons = __importStar(require("./cancellationReasons"));
exports.kafkaTopics = __importStar(require("./kafkaTopics"));
exports.ledgerTransactions = __importStar(require("./ledgerTransactions"));
exports.mpms = __importStar(require("./mpms"));
exports.onfidoDocumentTypes = __importStar(require("./onfidoDocumentTypes"));
exports.operationStatus = __importStar(require("./operationStatus"));
exports.operationTypes = __importStar(require("./operationTypes"));
exports.operationTags = __importStar(require("./operationTags"));
exports.paymentMethodRestrictions = __importStar(require("./paymentMethodRestrictions"));
exports.paymentTypes = __importStar(require("./paymentTypes"));
exports.paymentStatus = __importStar(require("./paymentStatus"));
exports.phoneVerificationMethods = __importStar(require("./phoneVerificationMethods"));
exports.puris = __importStar(require("./puris"));
exports.userRoles = __importStar(require("./userRoles"));
exports.defaultImages = __importStar(require("./defaultImages"));
exports.userTiers = __importStar(require("./userTiers"));
exports.invitationStatus = __importStar(require("./invitationStatus"));
exports.userMigrationStatus = __importStar(require("./userMigrationStatus"));
exports.transitions = __importStar(require("./transitions"));
exports.bulkPayments = __importStar(require("./bulkPayments"));
exports.otpMethods = __importStar(require("./otpMethods"));
exports.thirdPartyAuthProviders = __importStar(require("./thirdPartyAuthProviders"));
exports.cryptoBannedCountriesAndDates = __importStar(require("./cryptoBannedCountriesAndDates"));
exports.signupSources = __importStar(require("./signupSources"));
exports.kount = __importStar(require("./kount"));
exports.wyreAccounts = __importStar(require("./wyreAccounts"));
exports.wyreCurrencies = __importStar(require("./wyreCurrencies"));
exports.auditReasons = __importStar(require("./auditReasons"));
exports.virtualCardConstants = __importStar(require("./virtualCardConstants"));
exports.matchingPeerTypes = __importStar(require("./matchingPeerTypes"));
exports.deviceTypes = __importStar(require("./deviceTypes"));
exports.verificationCodeTypes = __importStar(require("./verificationCodeTypes"));
exports.dlocal = __importStar(require("./dlocal"));
exports.rto = __importStar(require("./rto"));
exports.saasquatch = __importStar(require("./saasquatch"));
exports.moonpay = __importStar(require("./moonpay"));
exports.payoneer = __importStar(require("./payoneer"));
exports.webappNames = __importStar(require("./webappNames"));
var regexFormFields_1 = require("./regexFormFields");
Object.defineProperty(exports, "REGEX_FORM_FIELDS", { enumerable: true, get: function () { return regexFormFields_1.REGEX_FORM_FIELDS; } });
exports.AIRTM_REGEX = /airtm/i;
exports.SEQUENTIAL_CHARS_REGEX = /(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|012|123|234|345|456|567|678|789)/i;
exports.CONSECUTIVE_CHARS_REGEX = /(.)\1{2}/i;
exports.REGEX_CONSTANT_CASE = /^[A-Z_0-9]+[A-Z_0-9Ñ]+$/;
exports.REGEX_JWT = /^Bearer ([A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*)$/i;
exports.REGEX_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
exports.REGEX_UUID_LIST = /^([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}(,)*)+$/i;
exports.REGEX_PURI = /^([a-z]:*)+[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
exports.REGEX_PURI_LIST = /^(([a-z]:*)+[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}(,)*)+$/i;
exports.REGEX_USERNAME = /^[a-z0-9_-]{5,16}$/;
// This are used by Onix and Milotic.
// Todo: This shouldn't live in index, so let's move them to regexFormFields
exports.PHONE_COUNTRY_CODE_REGEX = /^\+\d{1,3}$/;
exports.PHONE_REGEX = /^\d{6,15}$/;
exports.PASSWORD_SPECIAL_CHARS_REGEX = /[-!@#$%^&*()_+|~=`{}[\]:";'<>?,.]/;
exports.PASSWORD_NUMBER_REGEX = /\d+/g;
exports.PASSWORD_LENGTH_REGEX = /^.{8,}/;
exports.PASSWORD_LETTER_REGEX = /[A-Za-z]+/g;
exports.POSTCODE_GBR_REGEX = /^[A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}$/i;
// E.g. a valid postal code should match 12345 and 12345-6789, but not 1234, 123456, 123456789, or 1234-56789.
exports.WYRE_POSTAL_CODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
exports.MOBILE_PIN_REGEX = /^\d{4}$/;
exports.AIRTM_MIN_AGE = 18;
exports.MAX_CREATED_PEER_TRANSFERS = 2;
exports.MAX_TAKEN_PEER_TRANSFERS = 10;
exports.MAX_UNCONFIRMED_ACCEPTED_SELLS = 5;
exports.UNLIMITED_ACCEPTORS = process.env.UNLIMITED_ACCEPTORS
    ? process.env.UNLIMITED_ACCEPTORS.split(',')
    : ['withdrawals@airtm.com', 'withdrawalsmx@airtm.com', 'alex@airtm.com', 'josh@airtm.com'];
exports.MAX_SEND_REQUEST_OPERATIONS = 25;
exports.MAX_SEND_REQUESTS_SAME_USER = 5;
exports.MAX_SEND_REQUESTS_MONTHLY = 12;
exports.MAX_AMOUNT_SEND_REQUEST_USD = 5000;
exports.MIN_AMOUNT_SEND_USD = 0.1;
exports.MIN_AMOUNT_SEND_CRYPTO = 0.000001;
exports.MIN_AMOUNT_ENTERPRISE_PAYOUT = 1;
exports.DEFAULT_SEND_AMOUNT_LIMIT = 2500;
exports.DEFAULT_PARTNER_SEND_AMOUNT_LIMIT = 1000000;
exports.DEFAULT_SEND_FREE_AMOUNT_LIMIT = 2500;
exports.MAX_AIRMXN_MONTHLY_TRADE_OUT = 10000;
exports.MAX_SECONDARY_EMAILS = 3;
exports.LANGUAGES = [
    {
        name: 'English',
        nativeName: 'English',
        isoCode: 'en',
    },
    {
        name: 'Spanish',
        nativeName: 'Español',
        isoCode: 'es',
    },
    {
        name: 'Portuguese',
        nativeName: 'Português',
        isoCode: 'pt',
    },
];
exports.DEFAULT_CURRENCY_PRECISION = 2;
